import { service } from '@ember/service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import type TeamModel from 'scaleflow/models/team';
import type DepartmentModel from 'scaleflow/models/department';
import type StoreService from 'scaleflow/services/store';
import DepartmentValidations from 'scaleflow/validators/department';

export default class DepartmentsDepartmentSettingsController extends Controller {
  @service('store') declare store: StoreService;
  departmentValidations = DepartmentValidations;

  @action
  async removeTeam(team: TeamModel) {
    team.department = null;
    void (await (team as any).save());
  }

  @action
  async setTeams(department: DepartmentModel, e: string[]) {
    const teams = e.map((id) => this.store.peekRecord('team', id) as TeamModel);

    const promises = [];
    // Remove department from teams that are no longer assigned
    const currentTeams = await department.teams;
    for (const team of currentTeams.slice()) {
      if (!teams.includes(team)) {
        team.department = null;
        promises.push(team.save());
      }
    }

    // Set department on new teams
    for (const team of teams) {
      team.department = department;
      promises.push(team.save());
    }

    await Promise.all(promises);
  }

  @action
  rollbackChanges(changeset: any) {
    changeset.rollback();
  }
}
